<template>
    <div class="inline-flex company-capacity-row">
        <div class="company-capacity-corner-cell">{{ trans('Total') }}</div>
        <div class="weeks">
            <div
                v-for="(week, index) in weeks"
                :index="'company-capacity-week-' + index"
                class="week"
            >
                <div class="week-info" :style="getWeekStyle(week)">
                    {{ getWeekCapacityInHours(week) }}
                </div>
                <div class="days">
                    <capcity-day-component
                        v-for="date in daysInWeek(week)"
                        :key="index + '-' + date"
                        :date="date"
                        :item-id="0"
                        :item-capacity="getCapacity(date)"
                        :currentZoom="currentZoom"
                    ></capcity-day-component>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import CapcityDayComponent from './CapcityDayComponent';
import { minutesToTime } from '../../../utils/minutesToTime';

export default {
    components: {
        CapcityDayComponent,
    },
    computed: {
        ...mapState('planning', [
            'dateStart',
            'dateEnd',
            'currentZoom',
            'dates',
            'capacityCompany',
        ]),
        weeks() {
            let dateStart = this.dateStart;
            let dateEnd = this.dateEnd;
            if (!dateStart || !dateEnd) return;

            let weeks = [];
            while (dateStart.isBefore(dateEnd)) {
                weeks.push(dateStart);
                dateStart = dateStart.plusWeeks(1);
            }
            return weeks;
        },
    },
    methods: {
        daysInWeek(week) {
            let days = [];
            let nextWeek = week.plusWeeks(1);
            this.dates.forEach((date) => {
                if (week <= date.localDate && date.localDate < nextWeek) {
                    days.push(date);
                }
            });
            return days;
        },
        getCapacity(date) {
            return this.capacityCompany[date.formatted] ?? false;
        },
        getWeekCapacity(week) {
            const daysInWeek = this.daysInWeek(week);
            let availableTime = 0;
            let workedTime = 0;
            daysInWeek.forEach((date) => {
                let capacityForDay = this.capacityCompany[date.formatted] ?? false;
                if (!capacityForDay) {
                    return false;
                }
                availableTime += capacityForDay.available - capacityForDay.absence;
                workedTime += capacityForDay.planned;
            });
            return {
                availableTime: availableTime,
                workedTime: workedTime,
            };
        },
        getWeekCapacityInHours(week) {
            const capacity = this.getWeekCapacity(week);

            if (!capacity) {
                return '';
            }

            if( capacity.availableTime === 0 ){
                return (
                    minutesToTime(capacity.workedTime) +
                    ' / ' +
                    minutesToTime(capacity.availableTime)
                );
            }

            let planned = ((capacity.workedTime / capacity.availableTime) * 100).toFixed(2);

            if (isNaN(planned)) {
                return '';
            }
            planned = parseFloat(planned).toFixed(2);

            return (
                minutesToTime(capacity.workedTime) +
                ' / ' +
                minutesToTime(capacity.availableTime) +
                ' (' +
                planned +
                '%)'
            );
        },
        getWeekStyle(week) {
            const capacity = this.getWeekCapacity(week);

            if (!capacity) {
                return '';
            }

            let planned = Math.round((capacity.workedTime / capacity.availableTime) * 10000) / 100;
            if (planned > 100 || (capacity.availableTime === 0 && capacity.workedTime > 0) ) {
                planned = 100;
            }
            if( isNaN(planned) ){
                planned = 0;
            }
            return {
                background:
                    'linear-gradient(90deg, #FFCCCC ' + planned + '%, #BBFFDD ' + planned + '%)',
            };
        },
    },
};
</script>

<style lang="scss">
.company-capacity-row {
    border-top: 2px solid #ccc;
    border-bottom: 1px solid #ccc;
}
.company-capacity-row .day-capacity:hover {
    cursor: auto !important;
}
.week-info {
    border-right: 1px solid #ccc;
}
.company-capacity-corner-cell {
    box-sizing: border-box;
    position: -webkit-sticky; /* for Safari */
    position: sticky;
    top: 0;
    left: 0;
    z-index: 800;
    width: 250px;
    padding-left: 10px;
    line-height: 50px;
    border-right: 1px solid #ccc;
    background: #fff;
    font-style: italic;
}
</style>
